import { useLocalStorageState } from "@istari-frontend/shared";

import { EXPERIMENTAL_FEATURES } from "./registry";
import type { ExperimentalFeatureId } from "./registry";
import {
  readExperimentalFeatureEnv,
  resolveExperimentalFeature,
  warnAboutMisconfiguredExperimentalIds,
} from "./resolve-experimental-feature";
import type { ExperimentalFeatureState } from "./resolve-experimental-feature";

export type ExperimentalFeatureToggle = ExperimentalFeatureState & {
  setEnabled: (next: boolean) => void;
};

export function useExperimentalFeatureToggle(id: ExperimentalFeatureId): ExperimentalFeatureToggle {
  const feature = EXPERIMENTAL_FEATURES[id];
  // Tri-state: an absent key means "no user choice yet", so the environment default applies.
  const [storedChoice, setStoredChoice] = useLocalStorageState<boolean | null>(feature.storageKey, null);
  const env = readExperimentalFeatureEnv();

  warnAboutMisconfiguredExperimentalIds(env);

  return { ...resolveExperimentalFeature(feature, env, storedChoice), setEnabled: setStoredChoice };
}

export function useExperimentalFeature(id: ExperimentalFeatureId): ExperimentalFeatureState {
  const { setEnabled, ...state } = useExperimentalFeatureToggle(id);

  return state;
}
